module.exports = "/_next/static/images/img__form1_right_bottom_desktop-771bf631522b01bb35a62e6c3e1de740.png";